import { NgModule } from "@angular/core";

import { GrowlService } from "./growl.service";

/**
 * Module for displaying growl notifications
 * Components are defined in {@link GrowlComponentsModule}
 */
@NgModule({
  providers: [GrowlService]
})
export class GrowlServiceModule {}
